<script setup>
/**
 * FormControlAccountSettingsPrimaryDomain
 * Replaces 'extends: FormControlTypeText' with Composition.
 * Validates that the primary domain does not use restricted system domains.
 */
import {ref, watch} from 'vue'
import FormControlTypeText from '@/common/form-control-type/FormControlTypeText.vue'

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number],
        default: ''
    }
})

const baseControl = ref(null)

/**
 * Syncs the error message to the field object and the native DOM element
 * @param {string} msg
 */
const validate = (msg) => {
    props.field.error = msg

    // Access the child component's ref safely via baseControl.value
    const el = baseControl.value?.$refs?.field

    if (el) {
        el.setCustomValidity(msg)
        el.checkValidity()
    }
}

watch(() => props.value, (newValue) => {
    validate('')

    const restrictedDomains = [
        'creativecms.io'
    ]

    restrictedDomains.forEach((domain) => {
        if (newValue && newValue.includes(domain)) {
            const msg = `<strong>${domain}</strong> domains may not be used.`
            validate(msg)
        }
    })
}, {immediate: true})
</script>

<template>
    <FormControlTypeText v-bind="$props" ref="baseControl"/>
</template>